import React from "react";

const UserModal = ({ user, onClose }) => {
  if (!user) return null;

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">
            User Details
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-lg"
          >
            ✕
          </button>
        </div>

        {/* Profile Section */}
        <div className="flex flex-col items-center">
          <img
            src={user.profileImageUrl || "N/A"}
            alt={user.name || "N/A"}
            className="w-28 h-28 rounded-full object-cover mb-3"
          />
          <h3 className="text-2xl font-bold text-gray-900">{user.name || "Unknown User"}</h3>
          <p className="text-gray-600">{user.bio || "N/A"}</p>
        </div>

        {/* Info Grid */}
        <div className="mt-6 grid grid-cols-2 gap-6 text-sm">
          <div>
            <p className="font-semibold text-gray-700">Email:</p>
            <p className="text-gray-600 truncate w-40 ">{user.email || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Phone:</p>
            <p className="text-gray-600">{user.phone || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Gender:</p>
            <p className="text-gray-600">{user.gender || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">DOB:</p>
            <p className="text-gray-600">{user.dateOfBirth || "N/A"}</p>
          </div>

          <div>
            <p className="font-semibold text-gray-700">Profession:</p>
            <p className="text-gray-600">{user.profession || "N/A"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Location:</p>
            <p className="text-gray-600">{user.location || "N/A"}</p>
          </div>

          <div>
            <p className="font-semibold text-gray-700">Master:</p>
            <p className="text-gray-600">{user.isMaster ? "Yes" : "No"}</p>
          </div>
          <div>
            <p className="font-semibold text-gray-700">Partner:</p>
            <p className="text-gray-600">{user.isPartner ? "Yes" : "No"}</p>
          </div>

          <div className="col-span-2">
            <p className="font-semibold text-gray-700">Interests:</p>
            <p className="text-gray-600">
              {user.interests && user.interests.length > 0
                ? user.interests.join(", ")
                : "N/A"}
            </p>
          </div>

          <div className="col-span-2">
            <p className="font-semibold text-gray-700">Match Preferences:</p>
            <ul className="list-disc list-inside text-gray-600">
              <li>Purpose: {user.matchPreferences?.purpose}</li>
              <li>Min Age: {user.matchPreferences?.minAge}</li>
              <li>Max Age: {user.matchPreferences?.maxAge}</li>
              <li>Max Distance: {user.matchPreferences?.maxDistance} km</li>
            </ul>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserModal;
